.leaderboard {
    height: 100%;
    overflow-y: auto;
}
